module.exports = __webpack_public_path__ + "img/2.ebe8fbbe.jpg";